import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IPromiseOfPayment } from '@dch/billing-business-logic';
import { EntityManager } from '@dch/entity-manager';
import { of } from 'rxjs';
import { map, catchError, withLatestFrom, switchMap } from 'rxjs/operators';
import { PROMISE_OF_PAYMENT_ENTITY } from 'src/app/my-bill/config/my-bill-entity.config';
import {
  getPromiseOfPaymentFailure,
  getPromiseOfPaymentRequest,
  getPromiseOfPaymentSuccess,
} from '../actions';
import { ApplicationState } from '../reducers';
import { selectCustomer } from '../selectors/customer-account.selector';

@Injectable()
export class PromiseOfPaymentEffects {
  getPromiseOfPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getPromiseOfPaymentRequest),
      map(({ billingAccountNumber }) => billingAccountNumber),
      withLatestFrom(this.store.select(selectCustomer)),
      switchMap(([billingAccountNumber, customer]) =>
        EntityManager.getEntity<IPromiseOfPayment>(PROMISE_OF_PAYMENT_ENTITY, {
          billingAccountNumber,
          cdbId: customer.customerId,
        }).pipe(
          map((entity) =>
            entity.value
              ? getPromiseOfPaymentSuccess({
                  billingAccountNumber,
                  promiseOfPayment: entity.value,
                })
              : getPromiseOfPaymentFailure({ billingAccountNumber })
          ),
          catchError(() =>
            of(getPromiseOfPaymentFailure({ billingAccountNumber }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>
  ) {}
}
